import { render, staticRenderFns } from "./ComboOptionEditDialog.vue?vue&type=template&id=70c21424&scoped=true&"
import script from "./ComboOptionEditDialog.vue?vue&type=script&lang=ts&"
export * from "./ComboOptionEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ComboOptionEditDialog.vue?vue&type=style&index=0&id=70c21424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c21424",
  null
  
)

export default component.exports